import { createStore } from 'vuex';
import VuexPersistence from 'vuex-persist';

import navigation from './modules/navigation';
import system from './modules/system';
import user from './modules/user';

const debug = !import.meta.env.PROD;

const vuexSession = new VuexPersistence({
    storage: window.sessionStorage,
});

export const store = createStore({
    modules: {
        navigation,
        system,
        user,
    },
    plugins: [vuexSession.plugin],
    strict: debug,
});

export default store;
